<template>
  <div>
    <div class="form__row">
      <FilterInput title="Filter feeds"
                   :filterList="feeds"
                   v-on:filter="onFilterFeeds"
      ></FilterInput>
    </div>

    <Loader v-if="areFeedsLoading"></Loader>
    <div v-else class="feed-list__container">
      <ul class="selectable-list"
          v-if="filteredFeeds.length && !areFeedsLoading">
        <li class="selectable-list__item"
            :class="{'active': chosenFeed && feed === chosenFeed}"
            v-for="(feed, i) in filteredFeeds"
            :key="feed + i"
            @click="$emit('choseFeed', feed)"
        >
          <div><b>{{ feed.name }}</b></div>
          <div style="font-size: small">{{ feed.environment }}</div>
        </li>
      </ul>
    </div>
    <FeedOnArenasPopup
      v-if="popups.feedOnArenasPopup"
      :chosenFeed="chosenFeed"
      v-on:close="togglePopup('feedOnArenasPopup', false)">
    </FeedOnArenasPopup>
  </div>
</template>

<script>
import Loader from '../../Loader/Loader.vue'
import FilterInput from '../../FilterInput/FilterInput.vue'
import FeedOnArenasPopup from '../FeedOnArenasPopup/FeedOnArenasPopup.vue'

export default {
  name: 'FeedsList',
  components: {Loader, FilterInput, FeedOnArenasPopup},
  props: ['chosenFeed'],
  data() {
    return {
      feeds: [],
      filteredFeeds: [], // used to show feeds
      areFeedsLoading: false,
      popups: {
        feedOnArenasPopup: false
      }
    }
  },
  created: function () {
    this.getFeeds()
  },
  methods: {
    onFilterFeeds: function (feeds) {
      this.filteredFeeds = feeds
    },
    getFeeds: function () {
      this.areFeedsLoading = true

      this.$gameApi.get(`/feeds`).then(feeds => {
        this.feeds = feeds;
        this.filteredFeeds = feeds;
        this.$emit('gettingFeed', this.feeds)
        this.areFeedsLoading = false
      }, error => {
        console.log(error)
        this.areFeedsLoading = false
      })
    },
    togglePopup: function (popupName, isVisible) {
      this.popups[popupName] = isVisible
    },
  }
}
</script>

<style scoped lang="scss" src="./FeedList.scss"></style>
